<template>
    <el-container>
    <el-header style="height: 120px;">
      <div class="all-search">
      <div class="search-input" >
        <el-input v-model="productname" placeholder="请输入产品名字" ></el-input>
      </div>
      <div class="search-button" >
        <el-button type="primary"  @click="search">搜索</el-button>
      </div>
      <div class="search-reset" >
        <el-button type="primary"  @click="searchreset">重置</el-button>
      </div>
      </div>
<!--      <div class="addcss" >-->
<!--        <el-button type="primary"   @click="batchdelete">批量删除</el-button>-->
<!--      </div>-->
      <div class="addcss" >
        <el-button type="primary"   @click="addUserAccount">增加</el-button>
      </div>
    </el-header>
    <el-main style="line-height:50px;">
      <div class="tabledata">
        <el-table :data="appversions"  ref="multipleTable" style="width: auto" highlight-selection-row  @selection-change="handleSelect">
<!--          <el-table-column-->
<!--            type="selection"-->
<!--            v-if="showflag">-->
<!--          </el-table-column>-->
        <el-table-column type="index"    width="100px" :index="1 + this.queryInfo.pageSize * (this.queryInfo.pageNum - 1)"  label="序号" >
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" >
        </el-table-column>
        <el-table-column prop="techDesc" label="技术描述" >
        </el-table-column>
        <el-table-column prop="publishDate" label="发布日期" >
        </el-table-column>
        <el-table-column prop="version" label="版本号">
        </el-table-column>
        <el-table-column prop="innerVersion" label="内部版本号" >
        </el-table-column>
        <el-table-column prop="id" label="上传" >
          <template slot-scope="scope">
          <el-upload
            class="upload-demo"
            action="/api/data/appversion/upload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="3"
            :on-exceed="handleExceed"
            :on-success="uploadsuccess"
            :data="{ id: scope.row.id }"
            :file-list="files">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="路径" >
        </el-table-column>
        <el-table-column  label="操作" >
          <template slot-scope="scope">
          <el-link  @click="editVersion(scope.row)" style="color: #3B82F6">编辑</el-link>
          <el-link  @click="deleteVersion(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>

      </el-table>
      </div>
    </el-main>
    <el-footer><el-pagination background layout="sizes,total,prev, pager, next"  :page-sizes="[10, 15, 20, 25]"  :page-size="this.queryInfo.pageSize"  @size-change="handleSizeChange"  @current-change="changePage" :total="this.total" :current-page="this.queryInfo.pageNum">
    </el-pagination></el-footer>
    </el-container>
</template>

<script>
// import router from '../../router/index'
import axios from '../../../utils/request'
export default {
  data () {
    return {
      productname: '',
      appversions: [],
      selectRowsdata: [],
      queryInfo: {
        pageSize: 10,
        pageNum: 1
      },
      files: [],
      total: 0,
      path: ''
    }
  },

  // components: {
  //   table
  // },
  created: function () {
    this.methodToTrigger()
    console.log(this.appversions)
  },
  methods: {
    beforeAvatarUpload (file) {
      const isAPK = file.name.toLowerCase().endsWith('.apk')
      if (!isAPK) {
        this.$message.error('上传文件只能是apk格式!')
      }
      return isAPK
    },
    methodToTrigger: function () {
      if (this.productname === '水枪控制') {

      }
      axios.get(`/data/appversion/query?productname=${this.productname}&pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}&type=1`).then(res => {
        console.log('res', res)
        this.appversions = res.data.list
        this.total = res.data.total
      }).catch(error => {
        console.log('error', error)
      })
    },
    handleSizeChange: function (val) {
      this.queryInfo.pageSize = val
      this.methodToTrigger()
    },
    addUserAccount: function () {
      this.$router.push('/data/addappversion')
    },
    search: function () {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 10
      this.methodToTrigger()
    },
    searchreset: function () {
      this.productname = ''
      this.methodToTrigger()
    },
    changePage: function (val) {
      this.queryInfo.pageNum = val
      // axios
      //   .get(`/data/appversion/query?productname=${this.productname}&pageNum=${val}&pageSize=${this.queryInfo.pageSize}`)
      //   .then(function (res) {
      //     that.appversions = res.list
      //     // that.total = res.data.total
      //   }).catch(error => {
      //     console.log('111111', error)
      //   })
      this.methodToTrigger()
    },
    deleteVersion: function (val) {
      var that = this
      that.$confirm('删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/data/appversion/delete?id=${val}`)
          .then(function (res) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.methodToTrigger()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    editVersion: function (val) {
      console.log('val', val)
      this.$router.push({
        path: '/data/addappversion',
        query: {
          requesttype: 'update',
          productName: val.productName,
          techDesc: val.techDesc,
          publishDate: val.publishDate,
          version: val.version,
          innerVersion: val.innerVersion,
          id: val.id
        }
      })
    },
    handleSelect: function (val) {
      // this.selectedRows = selection // 更新选中数据
      // console.log('当前选中行：', row)
      // console.log('所有选中数据：', this.selectedRows)
      // this.selectRowsdata = this.selectedRows
      this.multipleSelection = val
      this.selectRowsdata = this.multipleSelection
      console.log(' this.selectRowsdata：', this.selectRowsdata)
    },
    batchdelete: function () {
      var that = this
      var ids = ''
      for (var i = 0; i < that.selectRowsdata.length; i++) {
        if (i !== that.selectRowsdata.length - 1) {
          ids = ids + that.selectRowsdata[i].id + ','
        } else {
          ids = ids + that.selectRowsdata[i].id
        }
      }
      if (that.showflag === false) {
        that.$refs.multipleTable.clearSelection()
        that.selectRowsdata = []
        that.ids = ''
      }

      if (ids !== '') {
        that.$confirm('删除这些记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete(`/data/account/delids?ids=${ids}`)
            .then(function (res) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              // that.showflag = false
              that.selectRowsdata = []
              that.ids = ''
              that.methodToTrigger()
            })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
          that.$refs.multipleTable.clearSelection()
          that.selectRowsdata = []
          that.ids = ''
        })
      }
      this.showflag = !this.showflag
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除`)
    },
    uploadsuccess (response, file, fileList) {
      this.path = response.data
      this.methodToTrigger()
    }
  }
}
</script>

<style scoped>
  .el-container {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:258px;
    height: 100%;
  }
  .el-header{
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    padding:0;
  }
  .el-footer {
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding:0;
  }

  .el-main {
    margin: 0px -43px;
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .addcss {
    float: right;
    margin-right: 10px;
  }
  .tabledata {
    height:70vh;
    margin-left: 20px;
  }

  .search-input{
    float:left;
    margin-left: 10px;
  }
  .search-button{
    float:left;
    margin-left: 10px;
  }
  .search-reset{
    float:left;
    margin-left: 10px;
  }
  .all-search{
    overflow: hidden;
    margin-left: -16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/appversion/appversion.vue